
  import {defineComponent, onMounted, reactive, toRefs} from "vue";
  import headerText from "@/layout/header/headerText";
  import {useRouter} from "vue-router";
  import axios from "axios";
  import netConfig from "@/util/env";
  import {formatText} from "@/util/common";

  export default defineComponent({
    name: 'index',
    setup(props, ctx) {
      const router = useRouter()
      const dataMap = reactive({
        newsText: headerText.menus[5],
        total: 0,
        page: 1,
        limit: 10,
      })
      const handleNewsPage = (number) => {
        console.log(number)
        dataMap.page = number
      }
      //跳转详情页面
      const gotoDetail = (btn) => {
        if (btn && btn.path) {
          const {path} = router.resolve({
            path: btn.path
          })

          window.open(path,"_blank")
        }
      }

      const getList = () =>{
        axios.get(`${netConfig.baseUrl}app/news/getNewsByColumnWithContent?columnId=001&page=${dataMap.page}&limit=${dataMap.limit}`).then(res => {
          dataMap.newsText.btns = []
          if (res.data) {
            res.data?.newsBase.list.forEach(btn => {
              dataMap.newsText.btns.push({
                img: netConfig.fileUrl + btn.newsImgurl,
                title: btn.newsTitle,
                description: btn.content,
                day: new Date(btn.publishTime).getDate(),
                month: new Date(btn.publishTime).getMonth() + 1,
                id: btn.id,
                path:'/news/detail/'+btn.id
              })
            })
            dataMap.total = res.data?.newsBase.total
          }
        })
      }
      onMounted(() => {
        getList()
      })
      return {
        ...toRefs(dataMap),
        handleNewsPage,
        gotoDetail,
        formatText
      }
    }
  })
